<div
  *ngIf="!isLoading; else loadingHeaderStage"
  [ngClass]="{
    'header-stage-reverse': content.reverse,
    'header-stage': !content.reverse,
    'header-stage--solo': !content.imageSlot2Src && !content.imageSlot3Src,
    'header-stage--medium': !content.imageSlot3Src && content.imageSlot2Src,
  }"
>
  <div class="header-stage-content">
    <!-- Headline Handling -->
    <ng-container [ngSwitch]="content.headlineSize">
      <h1 *ngSwitchCase="Headlines.H1">{{ content.headline }}</h1>
      <h2 *ngSwitchCase="Headlines.H2">{{ content.headline }}</h2>
      <h3 *ngSwitchCase="Headlines.H3">{{ content.headline }}</h3>
      <h4 *ngSwitchCase="Headlines.H4">{{ content.headline }}</h4>
      <h5 *ngSwitchCase="Headlines.H5">{{ content.headline }}</h5>
      <h6 *ngSwitchCase="Headlines.H6">{{ content.headline }}</h6>
    </ng-container>

    <!-- Paragraph -->
    <div class="paragraph" [innerHTML]="content.paragraph"></div>

    <!-- Button Wrapper -->
    <div class="button-wrapper" *ngIf="content.actionType === 'button'">
      <hdi-button
        *ngIf="content.buttonLabel"
        [label]="content.buttonLabel | capitalize"
        [title]="content.buttonTitle ?? ''"
        [isWithoutIcon]="true"
        [type]="content.buttonType || ButtonType.PRIMARY"
        [iconName]="content.buttonIcon"
        [href]="content.href"
        [hrefType]="content.hrefType ?? HrefType.ANGULAR_ROUTE"
        [fragment]="content.fragment ?? ''"
        [target]="content.target"
        [disabled]="!content.href"
        (clickEvent)="handleButtonClick($event, content.target, content.href)"
      ></hdi-button>
      <hdi-link
        *ngIf="content.optionalButtonLabel"
        [label]="content.optionalButtonLabel | capitalize"
        [title]="content.optionalButtonTitle ?? ''"
        [type]="content.optionalLinkType ?? LinkType.PRIMARY_ARROW"
        [hrefType]="content.optionalHrefType ?? HrefType.ANGULAR_ROUTE"
        [href]="content.optionalHref ?? ''"
        [fragment]="content.optionalFragment ?? ''"
        [target]="content.optionalTarget"
        [video]="content.optionalVideo"
      ></hdi-link>
    </div>

    <!-- Inpage Search   -->
    <hdi-inpage-search
      *ngIf="content.actionType === 'search'"
      class="inpage-search"
      [placeholder]="content.searchPlaceholder!"
      [searchGroup]="content.searchGroup"
    ></hdi-inpage-search>
  </div>

  <!-- Image Handling -->
  <div
    class="header-stage-image"
    [ngClass]="{
      'header-stage-image--mirror': content.imageMirror,
      'header-stage-image--badge': content.showBadge,
      'header-stage-image--only-medium':
        !content.imageSlot3Src && content.imageSlot2Src,
      'header-stage-image--solo':
        !content.imageSlot2Src && !content.imageSlot3Src,
    }"
  >
    <hdi-modal-function
      [showIcon]="content.showPlayButton ?? false"
      [imageSrc]="content.imageSrc"
      [imageAlt]="content.imageAlt"
      [imageTitle]="content.imageTitle"
      [playButtonSize]="content.playButtonSize ?? Sizes.MEDIUM"
      [videoSizes]="Sizes.LARGE"
      [type]="ModalFunctionType.VIDEO_HEADER_STAGE"
      [videoSrc]="content.videoSrc!"
      [videoId]="content.videoId!"
      [videoTitle]="content.videoTitle ?? ''"
      [thumbnailSrc]="content.thumbnailSrc!"
      [imageObjectPosition]="content.imageObjectPosition!"
      [lazy]="false"
    ></hdi-modal-function>

    <div
      class="header-stage-slot-2"
      *ngIf="
        content &&
        content.imageSlot2Src &&
        content.imageSlot2Src.trim().length > 0
      "
    >
      <hdi-image
        [src]="content.imageSlot2Src || ''"
        [alt]="content.imageSlot2Alt"
        [title]="content.imageSlot2Title"
        [lazy]="false"
      ></hdi-image>
    </div>

    <div
      class="header-stage-slot-3"
      *ngIf="
        content &&
        content.imageSlot3Src &&
        content.imageSlot3Src.trim().length > 0
      "
    >
      <hdi-image
        [src]="content.imageSlot3Src || ''"
        [alt]="content.imageSlot3Alt"
        [title]="content.imageSlot3Title"
        [lazy]="false"
      ></hdi-image>
    </div>

    <!-- Badge -->
    <div
      *ngIf="content.showBadge"
      class="header-stage-badge"
      [style.backgroundColor]="content.iconBadgeColor"
    >
      <ng-container *ngIf="content.type === 'icon'">
        <hdi-icon
          [iconName]="content.iconBadgeIconName!"
          [color]="content.iconBadgeIconColor"
          [size]="content.iconBadgeIconSize!"
        ></hdi-icon>
      </ng-container>

      <ng-container *ngIf="content.type === ''">
        <hdi-image
          [src]="content.imageBadgeSrc || ''"
          [alt]="content.imageBadgeTitle"
        ></hdi-image>
      </ng-container>
    </div>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingHeaderStage>
  <div
    [ngClass]="{
      'header-stage-reverse': content.reverse,
      'header-stage': !content.reverse,
      'header-stage--solo': !content.imageSlot2Src && !content.imageSlot3Src,
      'header-stage--medium': !content.imageSlot3Src && content.imageSlot2Src,
    }"
  >
    <div class="header-stage-content">
      <div class="headline-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="paragraph-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="button-wrapper" *ngIf="content.actionType === 'button'"></div>
      <div class="inpage-search"></div>
    </div>
    <div
      class="header-stage-image"
      [ngClass]="{
        'header-stage-image--mirror': content.imageMirror,
        'header-stage-image--badge': content.showBadge,
        'header-stage-image--only-medium':
          !content.imageSlot3Src && content.imageSlot2Src,
        'header-stage-image--solo':
          !content.imageSlot2Src && !content.imageSlot3Src,
      }"
    >
      <div class="modal-function-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div
        class="header-stage-slot-2"
        *ngIf="
          content &&
          content.imageSlot2Src &&
          content.imageSlot2Src.trim().length > 0
        "
      ></div>
      <div
        class="header-stage-slot-3"
        *ngIf="
          content &&
          content.imageSlot3Src &&
          content.imageSlot3Src.trim().length > 0
        "
      ></div>
    </div>
  </div>
</ng-template>
